import React from 'react';
import PropTypes from 'prop-types';

const borderColor = '#c3c3c3';
const borderStyle = { border: `1px solid ${borderColor}` };
const cellStyle = { textAlign: 'start', padding: '5px 5px', borderLeft: `1px solid ${borderColor}` };

const GraphsConditionsLegend = ({ config }, context) => {
  const orderedConfig = React.useMemo(() => {
    if (config && config.condition_name && Array.isArray(config.condition_name)) {
      return config.condition_name.map((label, index) => ({
        index,
        label,
        distance: config.condition_distance?.[index],
        set: config.short_or_long_set?.[index],
      }))
        .sort((a, b) => Boolean(b.distance) - Boolean(a.distance));
    } else {
      return [];
    }
  }, [config])
  return (
    <div
      style={{
        padding: '10px',
      }}>
      <p style={{ margin: '0 0 10px 0', fontSize: '16px', color: '#333', textAlign: 'start' }}>Conditions</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {Array.isArray(config?.condition_name) && 
        <table style={{ margin: '0px', ...borderStyle }}>
          <thead>
            <tr style={borderStyle}>
              <th style={cellStyle}>#</th>
              <th style={cellStyle}>{context.t('condition_distance')}</th>
              {/* <th style={cellStyle}>{context.t('condition_set')}</th> */}
              <th style={cellStyle}>{context.t('condition_type')}</th>
            </tr>
          </thead>
          <tbody>
            {orderedConfig
              .filter((configItem) => configItem.distance)
              .map((configItem) => (
              <tr key={configItem.index} style={borderStyle}>
                <td style={cellStyle}>{configItem.index + 1}</td>
                <td
                  style={cellStyle}
                  title={configItem.distance}
                >{configItem.distance || '--'}</td>
                {/* <td
                  style={{ maxWidth: '50px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...cellStyle }}
                  title={configItem.set}
                >{configItem.set || '--'}</td> */}
                <td
                  style={{ maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...cellStyle }}
                  title={configItem.label}
                >{configItem.label}</td>
              </tr>
            ))}
          </tbody>
        </table>
        }
      </div>
    </div>
  );
};

GraphsConditionsLegend.propTypes = {
  config: PropTypes.arrayOf(PropTypes.string).isRequired,
};

GraphsConditionsLegend.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default GraphsConditionsLegend;